import { render, staticRenderFns } from "./keralaForestDepartment.vue?vue&type=template&id=454f92ba"
import script from "./keralaForestDepartment.vue?vue&type=script&lang=js"
export * from "./keralaForestDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports